module.exports = __webpack_public_path__ + "static/media/landingSwipeOne.5a31d355.png";